module.exports = __webpack_public_path__ + "static/media/latest-blog-web-versn.01e2bed0.svg";